import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  :root {
    --reach-dialog: 1;
  }
  #mapa-main-container {
    font-size: 15px;
    color: ${props => props.theme.colors.gray400};
    font-family: ${props => props.theme.fonts.family.montserrat};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    input, button {
      font-family: ${props => props.theme.fonts.family.montserrat};
    }
  }

`;
